import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.imports = ReducerFuncs }

export {
  Reducers
}
